/* clemoa v3: kaydırmalı diziler, ürün filtreleri, renk örnekleri, galeri, SSS "daha fazla". Bağımlılık yok. */
(function () {
  'use strict';

  function rail(box) {
    if (box.dataset.c3Ready) return;
    box.dataset.c3Ready = '1';
    var track = box.querySelector('[data-c3-track]');
    if (!track) return;
    var prev = box.querySelector('[data-c3-prev]');
    var next = box.querySelector('[data-c3-next]');
    var dots = box.querySelector('[data-c3-dots]');
    var count = box.parentElement ? box.parentElement.querySelector('[data-c3-count]') : null;

    function items() {
      return Array.prototype.filter.call(track.children, function (el) { return !el.hidden; });
    }
    function step() {
      var it = items();
      if (it.length < 2) return track.clientWidth;
      return it[1].offsetLeft - it[0].offsetLeft;
    }
    function index() {
      var it = items();
      var x = track.scrollLeft;
      var best = 0;
      it.forEach(function (el, i) { if (Math.abs(el.offsetLeft - it[0].offsetLeft - x) < Math.abs(it[best].offsetLeft - it[0].offsetLeft - x)) best = i; });
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) best = it.length - 1;
      return best;
    }
    function buildDots() {
      if (!dots) return;
      dots.innerHTML = '';
      items().forEach(function (_, i) {
        var li = document.createElement('li');
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', (i + 1) + '. öğe');
        b.addEventListener('click', function () { var it = items(); track.scrollTo({ left: it[i].offsetLeft - it[0].offsetLeft }); });
        li.appendChild(b);
        dots.appendChild(li);
      });
    }
    function update() {
      var i = index();
      var n = items().length;
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      if (dots) Array.prototype.forEach.call(dots.querySelectorAll('button'), function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (count) count.textContent = (n ? i + 1 : 0) + ' / ' + n;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() }); });
    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(update, 60); }, { passive: true });
    window.addEventListener('resize', update);
    box.c3Refresh = function () { buildDots(); track.scrollTo({ left: 0 }); update(); };
    buildDots();
    update();
  }

  function filters(root) {
    var bar = root.querySelector('[data-c3-filters]');
    if (!bar || bar.dataset.c3Ready) return;
    bar.dataset.c3Ready = '1';
    var box = root.querySelector('[data-c3-rail]');
    bar.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-filter]');
      if (!b) return;
      Array.prototype.forEach.call(bar.querySelectorAll('button'), function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      var f = b.dataset.filter;
      Array.prototype.forEach.call(root.querySelectorAll('[data-cat]'), function (card) {
        card.hidden = !(f === 'tumu' || card.dataset.cat === f);
      });
      if (box && box.c3Refresh) box.c3Refresh();
    });
  }

  /* Kart üzerindeki renk noktaları: kart görselini değiştirir */
  function cardSwatches(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-c3-cardsw]'), function (group) {
      if (group.dataset.c3Ready) return;
      group.dataset.c3Ready = '1';
      var img = group.closest('.c3-pcard').querySelector('.c3-pcard__media img');
      group.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-src]');
        if (!b || !img) return;
        e.preventDefault();
        Array.prototype.forEach.call(group.querySelectorAll('button'), function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        img.removeAttribute('srcset');
        img.src = b.dataset.src;
      });
    });
  }

  /* Satın alma kutusu: renk örneği → varyant kimliği + galeri; küçük resimler */
  function buyBox(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-c3-buy]'), function (bx) {
      if (bx.dataset.c3Ready) return;
      bx.dataset.c3Ready = '1';
      var main = bx.querySelector('.c3-gal__main');
      var idInput = bx.querySelector('input[name="id"]');
      var label = bx.querySelector('[data-c3-colorname]');
      var thumbs = bx.querySelector('.c3-gal__thumbs');
      function show(src, alt) {
        if (!main || !src) return;
        main.removeAttribute('srcset');
        main.src = src;
        if (alt) main.alt = alt;
        if (thumbs) Array.prototype.forEach.call(thumbs.querySelectorAll('button'), function (t) { t.setAttribute('aria-pressed', t.dataset.src === src ? 'true' : 'false'); });
      }
      bx.addEventListener('click', function (e) {
        var sw = e.target.closest('.c3-swatch');
        if (sw) {
          e.preventDefault();
          Array.prototype.forEach.call(bx.querySelectorAll('.c3-swatch'), function (x) { x.setAttribute('aria-pressed', x === sw ? 'true' : 'false'); });
          if (label) label.textContent = sw.dataset.name;
          if (idInput && sw.dataset.variant) idInput.value = sw.dataset.variant;
          show(sw.dataset.src, sw.dataset.alt);
          return;
        }
        var th = e.target.closest('.c3-gal__thumbs button');
        if (th) { e.preventDefault(); show(th.dataset.src, th.dataset.alt); }
      });
    });
  }

  function faqMore(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-c3-more]'), function (b) {
      if (b.dataset.c3Ready) return;
      b.dataset.c3Ready = '1';
      b.addEventListener('click', function () {
        var faq = b.closest('.c3-faq');
        if (faq) faq.classList.add('is-open');
      });
    });
  }

  function init(root) {
    root = root || document;
    Array.prototype.forEach.call(root.querySelectorAll('[data-c3-rail]'), rail);
    Array.prototype.forEach.call(root.querySelectorAll('[data-c3-products]'), filters);
    cardSwatches(root);
    buyBox(root);
    faqMore(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* clemoa: sessiz ürün videoları (clm-video). Görünürken oynar, ekrandan çıkınca durur; düğmeyle durdur/oynat.
   Hareket azaltma tercihinde otomatik oynamaz. */
(() => {
  const kutular = document.querySelectorAll('[data-c3-vid]');
  if (!kutular.length) return;
  const azalt = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const durum = (kutu, oynuyor) => {
    kutu.classList.toggle('is-paused', !oynuyor);
    const btn = kutu.querySelector('[data-c3-vid-btn]');
    if (btn) btn.setAttribute('aria-label', oynuyor ? 'Videoyu durdur' : 'Videoyu oynat');
  };
  const oynat = (kutu) => {
    const v = kutu.querySelector('video');
    const p = v.play();
    if (p && p.catch) p.catch(() => durum(kutu, false));
    durum(kutu, true);
  };
  const gozcu = 'IntersectionObserver' in window ? new IntersectionObserver((girdiler) => {
    girdiler.forEach((g) => {
      const kutu = g.target;
      if (kutu.dataset.elle === '1') return;
      if (g.isIntersecting) oynat(kutu); else { kutu.querySelector('video').pause(); durum(kutu, false); }
    });
  }, { threshold: 0.35 }) : null;
  kutular.forEach((kutu) => {
    const v = kutu.querySelector('video');
    const btn = kutu.querySelector('[data-c3-vid-btn]');
    durum(kutu, false);
    if (btn) btn.addEventListener('click', () => {
      kutu.dataset.elle = '1';
      if (v.paused) oynat(kutu); else { v.pause(); durum(kutu, false); }
    });
    if (!azalt && gozcu) gozcu.observe(kutu);
  });
})();
